import { useFilterEmployeeDeductionContext } from "./filter-employee-deduction.context";

export function FilterEmployeeDeduction() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeDeductionContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}